import { render, staticRenderFns } from "./SplitListDetail.vue?vue&type=template&id=17dbef31&scoped=true&"
import script from "./SplitListDetail.vue?vue&type=script&lang=js&"
export * from "./SplitListDetail.vue?vue&type=script&lang=js&"
import style0 from "./SplitListDetail.vue?vue&type=style&index=0&id=17dbef31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dbef31",
  null
  
)

export default component.exports